import VueInstance from 'vue';

export default {
    install(Vue) {
        Vue.prototype.$eventBus = Vue.$eventBus = new VueInstance();
    }
};
